import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const TrameService = {
    async getDetailstrame(id) {
        try {
            const result = await axios.get(`${apiUrl}/Trame/detailtrame/`+id);
            if (result) {
                return result.data;
            }
        } catch (error) {
            return error.response.data;
        }
    },
     async saveTrame(data) {
        try {
            const response = await axios.post(`${apiUrl}/Trame/inserttrame`, {
                mission_id: data.mission_planning_id,
                n_piece: data.n_piece,
                data: data.trame_data,
                total_debit: data.total_debit,
                total_credit: data.total_credit
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la sauvegarde:', error);
            throw error;
        }
    }
    
};

export default TrameService;
